/* My Acre guide gate (2026-08-24, Claude).
   Subscribes the visitor to the master leads list via Klaviyo's public client endpoint, then
   reveals the PDF straight away. Four deliberate choices:
     1. ONE master list plus an ma_interest property, not a list per category. A Klaviyo flow
        takes a single trigger list, so four lists would mean four flows and four copies of
        every email. Category views are dynamic segments off ma_interest instead.
     2. We do NOT use mode:'no-cors'. The old collection lead grab did, which meant it could
        never see a failure and showed "thank you" even when nothing was captured. A real
        response is checked here, and a real error is shown.
     3. The download is revealed on success rather than promised by email. If the capture
        fails we still hand over the guide, because refusing a reader the thing they asked
        for to protect a mailing list is the wrong trade.
     4. Validation uses the input's own checkValidity() rather than a hand-rolled regex. A
        regex here was rejecting valid addresses because of backslash escaping when this file
        was written through the API. The browser already knows what an email looks like.
   Property names carry the ma_ prefix set in the store profile, so the pop-ups Hayden builds
   in the Klaviyo UI and these gates stamp the same keys. */
(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  function boot() {
    document.querySelectorAll('[data-gg-form]').forEach(function (form) {
      if (form.dataset.ggBound) return;
      form.dataset.ggBound = '1';
      var wrap = form.closest('.ma-gg');
      var done = wrap.querySelector('[data-gg-done]');
      var err  = wrap.querySelector('[data-gg-err]');
      var btn  = form.querySelector('.ma-gg__btn');

      function reveal(message) {
        form.hidden = true;
        done.hidden = false;
        if (message) { err.hidden = false; err.textContent = message; done.appendChild(err); }
        try { window.open(form.dataset.ggUrl, '_blank', 'noopener'); } catch (e) {}
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailEl = form.email;
        var email = emailEl.value.trim();
        var first = form.first_name.value.trim();
        var ok = email.length > 3 && emailEl.checkValidity();
        emailEl.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (!ok) { err.hidden = false; err.textContent = 'That email address does not look right.'; return; }
        err.hidden = true;
        btn.disabled = true;
        btn.textContent = 'One moment';

        var payload = { data: { type: 'subscription', attributes: {
            custom_source: form.dataset.ggLabel || 'Guide gate',
            profile: { data: { type: 'profile', attributes: {
              email: email, first_name: first,
              properties: {
                ma_interest: form.dataset.ggInterest || '',
                ma_entry: 'collection-guide',
                ma_guide_requested: form.dataset.ggLabel || '',
                ma_source_url: window.location.href
              } } } } },
          relationships: { list: { data: { type: 'list', id: form.dataset.ggList } } } } };

        fetch(ENDPOINT + encodeURIComponent(form.dataset.ggCompany), {
          method: 'POST',
          headers: { 'content-type': 'application/json', revision: '2025-07-15' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (r.status === 202 || r.ok) { reveal(null); }
          else { reveal('We could not save your details, so you will not hear from us. The guide is still yours.'); }
        }).catch(function () {
          reveal('We could not save your details, so you will not hear from us. The guide is still yours.');
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();